export type Pagination = {
  page: number;
  itemsPerPage: number;
  pageStart?: number;
  pageStop?: number;
  pageCount?: number;
  itemsLength?: number;
  sortBy?: string[];
  sortDesc?: boolean[];
};

export function sortOrdering(pagination: Pagination): string | undefined {
  const sortDesc = pagination.sortDesc?.[0];
  const sortBy = pagination.sortBy?.[0];

  if (sortBy === undefined || sortDesc === undefined) {
    return undefined;
  }

  return (sortDesc ? '-' : '') + sortBy;
}
